import { AppData, Toast } from "../../../types";

import { AddToastPayload } from "../../../actions";

export type AddToastOptions = {
  appData: AppData;
  payload: AddToastPayload;
};

function* generateId(): Generator<number, number, number> {
  let i = 0;
  while (true) {
    yield i;
    i += 1;
  }
}
const idGenerator = generateId();

export function addToast({ appData, payload }: AddToastOptions): AppData {
  const id = idGenerator.next().value;
  const newToast: Toast = { id, ...payload };
  return { ...appData, toast: [...appData.toast, newToast] };
}
